import { getPath } from '@/router/common'

const baseUrl = {
  title: '对账列表',
  path: 'AccountStatement'
}

export default [
  {
    path: getPath('MainIndex', baseUrl),
    name: 'AccountStatement_MainIndex',
    component: () => import(/* webpackChunkName: "AccountStatement_MainIndex" */ '@/views/accountStatement/mainIndex/index.vue'),
    meta: {
      title: '对账列表'
    }
  },
  {
    path: getPath('StatementIndex', baseUrl),
    name: 'AccountStatement_StatementIndex',
    component: () => import(/* webpackChunkName: "AccountStatement_StatementIndex" */ '@/views/accountStatement/statementIndex/index.vue'),
    meta: {
      title: '对账单'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'AccountStatement_Index',
    component: () => import(/* webpackChunkName: "AccountStatement_Index" */ '@/views/accountStatement/index/index.vue'),
    meta: {
      title: '对账单明细'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'AccountStatement_AddOrEdit',
    component: () => import(/* webpackChunkName: "AccountStatement_AddOrEdit" */ '@/views/accountStatement/addOrEdit/index.vue'),
    meta: {
      title: '新增修改对账单'
    }
  }
]
